import { TopTab, TopTabItem } from "arkh";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useSizeClass } from "../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";

export function TeamScheduleAdminListFrequencySelector(props: {
  mode: "daily" | "weekly" | "monthly";
  setMode: (mode: "daily" | "weekly" | "monthly") => void;
  dailyTotalNum: number;
  weekly: number;
  monthly: number;
}) {
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  return (
    <TopTab isCompact={isCompact}>
      <TopTabItem
        detail={props.dailyTotalNum}
        selected={props.mode === "daily"}
        onPress={() => {
          props.setMode("daily");
        }}
      >
        <FormattedMessage
          defaultMessage="Daily"
          description="TeamScheduleAdmin daily frequency selector item"
        />
      </TopTabItem>
      <TopTabItem
        detail={props.weekly}
        selected={props.mode === "weekly"}
        onPress={() => {
          props.setMode("weekly");
        }}
      >
        <FormattedMessage
          defaultMessage="Weekly"
          description="TeamScheduleAdmin weekly frequency selector item"
        />
      </TopTabItem>
      <TopTabItem
        detail={props.monthly}
        selected={props.mode === "monthly"}
        onPress={() => {
          props.setMode("monthly");
        }}
      >
        <FormattedMessage
          defaultMessage="Monthly"
          description="TeamScheduleAdmin monthly frequency selector item"
        />
      </TopTabItem>
    </TopTab>
  );
}
